export { default } from '@nozbe/watermelondb/adapters/lokijs';

export const adapterConfig = {
  useWebWorker: false,
  useIncrementalIndexedDB: true,
};
